import clsx from 'clsx'
import React, {forwardRef, useEffect, useRef, useState} from 'react'

import {useScrollLock} from '../lock-body-scroll'
import {TRANSITION_DURATION} from './consts'
import {classes} from './MobileDrawer.classes'

type MobileDrawerOverlayProps = React.PropsWithChildren<{
  isSwiping: boolean
  closeDrawer?: VoidFunction
  onTouchStart: React.TouchEventHandler<HTMLDivElement>
  onTouchMove: React.TouchEventHandler<HTMLDivElement>
  onTouchEnd: React.TouchEventHandler<HTMLDivElement>
  opened?: boolean
  isDisabled?: boolean
  bgRef?: React.Ref<HTMLDivElement>
  className?: string
  isInsideContainer: boolean
}>

export const MobileDrawerOverlay = forwardRef<HTMLDivElement, MobileDrawerOverlayProps>(
  ({isInsideContainer, isSwiping, closeDrawer, opened, children, isDisabled, bgRef, className, ...events}, ref) => {
    // Чтобы перед закрытием пользователь успевал увидеть транзишен, немного откладываем анмаунт детей
    const [childrenVisible, setChildrenVisible] = useState(opened)
    const touchStartRef = useRef<number>()

    const onPressStart = () => {
      touchStartRef.current = Date.now()
    }

    const onPressEnd = (e: React.PointerEvent<HTMLDivElement>) => {
      if (touchStartRef.current && Date.now() - touchStartRef.current < 300) {
        e.stopPropagation()
        if (e.currentTarget === e.target) {
          closeDrawer?.()
        }
      }

      touchStartRef.current = undefined
    }

    useScrollLock(opened)

    useEffect(() => {
      if (!opened) {
        const timeout = setTimeout(() => {
          setChildrenVisible(false)
        }, TRANSITION_DURATION)
        return () => {
          clearTimeout(timeout)
        }
      } else {
        setChildrenVisible(true)
      }
    }, [opened])

    return (
      <div
        ref={ref}
        className={clsx(classes.overlay, isInsideContainer && classes.insideContainer.overlay, className)}
        {...events}
      >
        <div
          ref={bgRef}
          className={clsx(classes.overlayBg, {
            [classes.overlaySwiping]: isSwiping,
            [classes.overlayClosed]: !opened || isDisabled,
            [classes.insideContainer.overlayBg]: isInsideContainer,
          })}
          onPointerDown={onPressStart}
          onPointerUp={onPressEnd}
        />
        {childrenVisible && children}
      </div>
    )
  },
)
